"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2003ToJSON = exports.InlineResponse2003FromJSONTyped = exports.InlineResponse2003FromJSON = void 0;
function InlineResponse2003FromJSON(json) {
    return InlineResponse2003FromJSONTyped(json, false);
}
exports.InlineResponse2003FromJSON = InlineResponse2003FromJSON;
function InlineResponse2003FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accounts': json['accounts'],
    };
}
exports.InlineResponse2003FromJSONTyped = InlineResponse2003FromJSONTyped;
function InlineResponse2003ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accounts': value.accounts,
    };
}
exports.InlineResponse2003ToJSON = InlineResponse2003ToJSON;
